import { ADMISSION_TYPE_GUEST_LIST, AdmissionType } from '@domain/admission';

export const calculateDefaultMaxCapacity = (type: AdmissionType) => (type === ADMISSION_TYPE_GUEST_LIST ? '10' : '5');
